module.exports = __webpack_public_path__ + "static/media/CDM.89971e23.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/shgn/footerLogos/desktop/CDM.svg
// module id = 107
// module chunks = 0